// extracted by mini-css-extract-plugin
module.exports = {"new-label":"NewLabel_new-label__DUF79"};